export default __webpack_public_path__ + "static/media/review.3b890b80.svg";